import { Button, Form, Card, Dropdown } from "react-bootstrap";
import { ChevronLeft, Save, Printer, Edit, X } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { DatePicker, Grid, Input, List, Popover } from "antd";
import { CalendarOutlined, SearchOutlined } from "@ant-design/icons";
import classNames from "classnames";
import dayjs from "dayjs";
import { addConsultData } from "../../services/doctor/consultant/consultant";
import { getPrintSettings } from "../../services/doctor/print_settings/printSettings";
import { useAuth } from "../../services/authentication_API/authService";
import { getreferDoctor } from "../../services/doctor/referDoctor/referDoctor";
import SaveRXModal from "../consultant/SaveRXModal";
import { saveCertificate } from "../../services/doctor/certificate/certificate";
const { useBreakpoint } = Grid;

export default function PreviewCertificate() {
  const navigate = useNavigate();
  const { title, text,payload } = useLocation().state || {};
  const printRef = useRef(null);
  const [settings, setSettings] = useState();
  const { userData } = useAuth();
  const [show, setShow] = useState(false);
    const [saveRx, setSaveRx] = useState(null);
  const [printRx, setprintRx] = useState(null);
    const addConsultantData = async () => {
      try {
        const result = await saveCertificate({
         ...payload,
         print_html_view: printRef.current.innerHTML,
        });
        if (result.success) {
          console.log("auto saved:", result);
        }
      } catch (err) {
        console.error("Error:", err.message);
      }
    };
    const currentDate = dayjs().format("YYYY-MM-DD");
  
    useEffect(() => {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }
      addConsultantData();
    }, [saveRx, printRx]);

  const fetchPrintSettings = async () => {
    try {
      const result = await getPrintSettings(userData?.id);
      if (result.success) {
        console.log("Fetched Data:", result.data);
        const formData = result?.data;
        console.log("Formatted Data:", formData);
        setSettings(formData);
      } else {
        console.error(
          "Error:",
          result.error || "Failed to fetch Print Settings"
        );
      }
    } catch (err) {
      console.error("Exception:", err.message);
    }
  };

  // ✅ CSS Print Media Query Approach (Most Reliable)
  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open(
      "about:blank", // THIS FIXES SAFARI
      "printWin",
      "popup=yes,width=800,height=900"
    );
    printWindow.document.write(`
    <html>
      <head>
        <title>Prescription</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
          crossorigin="anonymous"
        />
        <style>
          @page {
            size: A4 portrait;
            margin: 0;
          }
          body, table, div, span, p {
            font-size: 16px !important;
          }

          html, body {
            width: 210mm;
            height: auto;
            margin: 0;
            padding: 0;
            background: white;
            overflow: hidden;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .print-wrapper {
            width: 100vw;
            max-width: 210mm;
            margin: 0 auto;
            box-sizing: border-box;
            padding: ${settings.prescription_print_header_margin || 0}% ${
      settings.prescription_print_right_margin || 0
    }% ${settings.prescription_print_footer_margin || 0}% ${
      settings.prescription_print_left_margin || 0
    }%;
            background: white;
            transform-origin: top center;
          }

          table {
            width: 100%;
            border-collapse: collapse;

          }
            .thick-border table,
            .thick-border th,
            .thick-border td {
            border-width: 0.5px !important;
            border-color: #2c2c2cff !important;
          }

           td {
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;
          }

          th {
            background: #f8f9fa;
            text-align: left;
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;

          }

          .no-print { display: none !important; }
          hr { border: 0; border-top: 1px solid #ccc; margin: 20px 0; }
        </style>
      </head>
      <body>
        <div id="print-area" class="print-wrapper">
          ${printContents}
        </div>
        <script>
          window.onload = function() {
            const content = document.getElementById('print-area');
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

            // Get A4 height in pixels at 96 DPI
            const A4_HEIGHT_PX = 1122; // 297mm ≈ 1122px
            const contentHeight = content.scrollHeight;

            // If content overflows one A4 page, scale it down
            if (contentHeight > A4_HEIGHT_PX) {
              const scale = A4_HEIGHT_PX / contentHeight;
              content.style.transform = 'scale(' + scale + ')';
              content.style.transformOrigin = 'top center';
              document.body.style.height = A4_HEIGHT_PX + 'px';
            } else if (isIOS) {
              // Avoid unnecessary downscaling (causes side gaps)
              content.style.transform = 'scale(1)';
              content.style.transformOrigin = 'top center';
              document.body.style.margin = '0';
              document.body.style.padding = '0';
              content.style.width = '100vw';
            }


            setTimeout(() => {
              window.focus();
              window.print();
              let attempts = 0;

function tryClose() {
  try {
    window.close();

    if (!window.closed && attempts < 10) {
      attempts++;
      setTimeout(tryClose, 300);
    }
  } catch (e) {
    if (attempts < 10) {
      attempts++;
      setTimeout(tryClose, 300);
    }
  }
}

window.onafterprint = tryClose;

// failsafe auto close after 1 second
setTimeout(tryClose, 1000);

            }, 500);
          };
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();

        let attempts = 0;
        function tryClose() {
          try {
            printWindow.close();
            if (!printWindow.closed && attempts < 10) {
              attempts++;
              setTimeout(tryClose, 400);
            }
          } catch {
            if (attempts < 10) {
              attempts++;
              setTimeout(tryClose, 400);
            }
          }
        }

        // Safari: onafterprint rarely works, but include it
        printWindow.onafterprint = tryClose;

        // Fallback close
        setTimeout(tryClose, 1500);
      }, 300);
    };
  };



  const isFirstRender = useRef(true);



  useEffect(() => {
    fetchPrintSettings();
  }, []);

  const testPopup = () => {
    const html = printRef.current.innerHTML;

    // Remove old iframe
    const oldIframe = document.getElementById("print-iframe");
    if (oldIframe) oldIframe.remove();

    // Create iframe (visible but transparent)
    const iframe = document.createElement("iframe");
    iframe.id = "print-iframe";
    iframe.style.position = "fixed";
    iframe.style.top = "0";
    iframe.style.left = "0";
    iframe.style.width = "100vw";
    iframe.style.height = "100vh";
    iframe.style.opacity = "0";
    iframe.style.pointerEvents = "none";
    iframe.style.zIndex = "-1";
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;

    doc.open();
    doc.write(`
    <html>
      <head>
        <title>Prescription</title>
        
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no"/>

        <link 
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css"
          crossorigin="anonymous"
        />

        <style>
          @page {
            size: A4 portrait;
            margin: 0;
          }

          body, table, div, span, p {
            font-size: 16px !important;
          }

          html, body {
            width: 210mm;
            height: auto;
            margin: 0;
            padding: 0;
            background: white;
            overflow: hidden;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .print-wrapper {
            width: 100vw;
            max-width: 210mm;
            margin: 0 auto;
            box-sizing: border-box;
            padding: ${settings.prescription_print_header_margin || 0}% 
                     ${settings.prescription_print_right_margin || 0}% 
                     ${settings.prescription_print_footer_margin || 0}% 
                     ${settings.prescription_print_left_margin || 0}%;
            background: white;
            transform-origin: top center;
          }

          table {
            width: 100%;
            border-collapse: collapse;
          }
          
          .thick-border table,
          .thick-border th,
          .thick-border td {
            border-width: 0.5px !important;
            border-color: #2c2c2cff !important;
          }

          td {
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;
          }

          th {
            background: #f8f9fa;
            text-align: left;
            border: 2px solid #ddd;
            padding: 8px;
            font-size: 16px;
          }

          .no-print { display: none !important; }

          hr { 
            border: 0; 
            border-top: 1px solid #ccc; 
            margin: 20px 0; 
          }
        </style>
      </head>

      <body>
        <div class="print-wrapper">
          ${html}
        </div>
      </body>
    </html>
  `);

    doc.close();

    // iPad Safari + Chrome iOS wait logic
    const waitUntilReady = () => {
      const state = doc.readyState;

      if (state === "complete" || state === "interactive") {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          });
        });
      } else {
        setTimeout(waitUntilReady, 50);
      }
    };

    waitUntilReady();
  };
  const isIpadSafari = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    // iPad Safari = iPad + WebKit + NOT Chrome
    const isIpad =
      /iPad/.test(ua) ||
      (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    const isWebkit = /WebKit/.test(ua);
    const isChrome = /CriOS/.test(ua); // Chrome on iOS

    return isIpad && isWebkit && !isChrome;
  };

  

  return (
    <div className="min-vh-100 bg-light">
      <div className="d-flex">
        {/* Left Sidebar - Marked as no-print */}
        <div
          className="bg-white border-end p-4 no-print"
          style={{ width: "auto" }}
        ></div>

        {/* Main Content - This will be printed */}
        <div className="flex-grow-1" style={{ padding: "1% 5%" }}>
  <div
    ref={printRef}
    id="print-area"
    className="bg-white rounded shadow-sm border p-4"
    style={{ position: "relative" }}   // 👈 important
  >
    {/* Date – Top Right */}
<div style={{ textAlign: "end", marginBottom: "10px" }}>
      <h1 style={{ fontWeight: "", fontSize: "16px" }}>Date: {dayjs().format("DD-MM-YYYY")}</h1>
    </div>

    {/* Title */}
    <div style={{ textAlign: "center", marginBottom: "40px" }}>
      <h1 style={{ fontWeight: "bold", fontSize: "24px" }}>{title}</h1>
    </div>

    {/* Certificate Body */}
    <div style={{ fontSize: "18px", lineHeight: "2" }}>
      <div
        style={{ marginBottom: "20px" }}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>

    <hr style={{ marginBottom: "20px" }} />

    {/* Footer */}
    <div className="d-flex justify-content-between align-items-end">
      <div></div>
      <div className="text-end">
        <div className="text-start">
          {settings?.doctor_signature_image_url && (
            <div className="mt-2 text-center" style={{ maxWidth: "200px" }}>
              <img
                src={settings.doctor_signature_image_url}
                alt="Signature Preview"
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
              />
            </div>
          )}
          <div className="fw-medium">
            {userData.name} {userData?.last_name}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
      </div>
      <div
        className="bg-white border-top px-4 py-3 no-print" // Changed border-bottom to border-top
        style={{
          position: "fixed", // Key: Fixes element relative to the viewport
          bottom: 0, // Key: Sticks it to the bottom edge
          left: 0, // Ensures it starts from the left edge
          width: "100%", // Ensures it spans the full width
          zIndex: 1000, // Ensures it stays on top of other content
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <Button
            variant="light"
            className="text-black d-flex align-items-center"
            onClick={() => {
              navigate(-1), addConsultantData();
            }}
          >
            <ChevronLeft size={16} className="me-2" />
            Back to Consult
          </Button>

          <div className="d-flex align-items-center gap-3">
            <Button variant="outline-secondary" onClick={() => setSaveRx(true)}>
              <Save size={16} className="me-2" />
              Save Rx
            </Button>
            {saveRx && <SaveRXModal />}

            {/* ✅ Print Button */}
            <Button
              variant="primary"
              onClick={() => {
                try {
                  if (isIpadSafari()) {
                    testPopup(); // ✔ works on iPad Safari
                  } else {
                    handlePrint(); // ✔ all other browsers
                  }
                  setprintRx(true);
                  setSaveRx(true);
                } catch (err) {
                  console.error("Print failed:", err);
                }
              }}
            >
              <Printer size={16} className="me-2" />
              Print Rx
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
